import { History } from "history";

import { ManualPurchaseRequest } from "../../interfaces";

//#region Assign Subscription Manually

export const MANUAL_SUBSCRIPTION = "MANUAL_SUBSCRIPTION";
export const MANUAL_SUBSCRIPTION_SUCCESS: any = "MANUAL_SUBSCRIPTION_SUCCESS";
export const MANUAL_SUBSCRIPTION_ERROR: any = "MANUAL_SUBSCRIPTION_ERROR";
export const RESET_MANUAL_SUBSCRIPTION: any = "RESET_MANUAL_SUBSCRIPTION";

export interface ManualSubscriptionAction {
  type: typeof MANUAL_SUBSCRIPTION;
  payload: {
    request: ManualPurchaseRequest;
    history: History;
  };
}

export interface ManualSubscriptionSuccessAction {
  type: typeof MANUAL_SUBSCRIPTION_SUCCESS;
  payload: null;
}

export interface ManualSubscriptionErrorAction {
  type: typeof MANUAL_SUBSCRIPTION_ERROR;
  payload: any;
}

export interface ResetManualSubscriptionAction {
  type: typeof RESET_MANUAL_SUBSCRIPTION;
  payload: any;
}

//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | ManualSubscriptionAction
  | ManualSubscriptionSuccessAction
  | ManualSubscriptionErrorAction
  | ResetManualSubscriptionAction;
